jQuery(document).ready(function ($) {
    var windowWidth = $(window).width();
    var emailInput;
    if (windowWidth < 1024) {
        var device = "mobile";
        emailInput = $(".splash-cta [name='m-new']");
    } else {
        var device = "comp";
        emailInput = $(".splash-cta [name='d-new']");
    }

    const START = $("button[name='start']");
    const SPLASH = $(".splash-cta");
    const NEW_QUIZ = $("button[name='new']");
    const ERROR = $(".splash-cta .error");
    const CID = $(".splash-cta").data("cid");
    const PHONE = $(".splash-cta").data("phone");
    const CLOSE = $(".splash-cta .title .close");

    START.click(async function () {
        if (CID) {
            if (PHONE) {
                goToSubQuiz(CID);
                return;
            } else {
                goToSubQuiz(CID, true);
                return;
            }
        }
        SPLASH.children().addClass("d-none");
        emailInput.removeClass("d-none");
        $(".splash-cta [name='new']").removeClass("d-none");
        listenToLogin();
    });

    async function listenToLogin() {
        CLOSE.click(function () {
            SPLASH.children().addClass("d-none");
            $(".splash-cta [name='start']").removeClass("d-none");
        })
        emailInput.keyup(function () {
            var value = $(this).val();
            if (simpleEmailCheck(value)) {
                NEW_QUIZ.attr("disabled", false);
            } else {
                NEW_QUIZ.attr("disabled", true);
            }
        });
        NEW_QUIZ.click(async function () {
            ERROR.addClass("d-none");
            const originalText = NEW_QUIZ.text();
            NEW_QUIZ.attr("disabled", true).text("טוען...");
            let email = emailInput.val();
            try {
                const icountRes = await axios.get(`https://subs.millsforpets.com/api/billing/hkByClientEmail?email=${email}`);
                //This is the case where the customer is already in the system
                if (icountRes.status == 200) {
                    const shopifyRes = await axios.post("https://subs.millsforpets.com/api/admin/customer", { email: email });
                    if (shopifyRes.data.phone) {
                        goToSubQuiz(shopifyRes.data.id);
                        return;
                    } else {
                        goToSubQuiz(shopifyRes.data.id, true);
                        return;
                    }
                }
            } catch (e) {
                //This is the case where the customer is not in the system
                if (e.status == 404) {
                    goToShopifyQuiz();
                    return;
                }
                console.log(e);
                ERROR.text("אופס. משהו השתבש! ניתן לנסות מאוחר יותר.");
                ERROR.removeClass("d-none");
                NEW_QUIZ.attr("disabled", false).text(originalText);
            }
        });
    }

    function simpleEmailCheck(value) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(value);
    }

    function goToSubQuiz(cid, fresh = false) {
        window.location = "https://subs.millsforpets.com/?cid=" + cid + "&fresh=" + fresh;
    }

    function goToShopifyQuiz() {
        window.location = "https://millsforpets.com/pages/quiz";
    }
});